import { Currency, ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";

// Fallback for accounts created before v3 exposed `country`.
const CURRENCY_COUNTRY: Partial<Record<Currency, string>> = {
  [Currency.USD]: "US",
  [Currency.CAD]: "CA"
};

export const selectorExternalBankAccountCountry = (
  externalBankAccount: ExternalBankAccount
): string | undefined =>
  externalBankAccount.country ??
  (externalBankAccount.currency
    ? CURRENCY_COUNTRY[externalBankAccount.currency]
    : undefined);
